var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUpload = function SvgUpload(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9871 1.69119C12.3468 1.30374 12.5266 1.11001 12.738 1.04145C12.9084 0.986183 13.0916 0.986183 13.262 1.04145C13.4733 1.11001 13.6532 1.30374 14.0129 1.69119L17.928 5.9087C18.6353 6.67056 18.9889 7.05149 18.9995 7.37771C19.008 7.63689 18.9011 7.88628 18.7083 8.05737C18.4656 8.27273 17.9488 8.27273 16.9151 8.27273L15.4 8.27273L10.6 8.27273L9.08485 8.27273C8.05119 8.27273 7.53436 8.27273 7.29167 8.05737C7.09886 7.88628 6.99201 7.63689 7.00047 7.37771C7.01112 7.05149 7.36474 6.67056 8.07198 5.9087L11.9871 1.69119Z",
    fill: "#2595FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 8.27273L10.6 17.8939C10.6 18.5 11.08 19.7121 13 19.7121C14.92 19.7121 15.4 18.5 15.4 17.8939L15.4 8.27273L10.6 8.27273Z",
    fill: "#2595FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5714 12.9H7.42857H7.42219C6.61946 12.9 6.00907 12.9 5.53698 12.9501C5.06271 13.0005 4.71293 13.1026 4.44013 13.3181C4.16392 13.5362 4.02968 13.8206 3.96418 14.2054C3.9 14.5824 3.9 15.068 3.9 15.6979L3.9 15.7077V21.2923L3.9 21.3021C3.9 21.932 3.9 22.4176 3.96418 22.7946C4.02968 23.1794 4.16392 23.4638 4.44013 23.6819C4.71293 23.8974 5.06271 23.9995 5.53698 24.0499C6.00907 24.1 6.61946 24.1 7.42218 24.1H7.42857H10.6037H15.4451H18.5714H18.5778C19.3805 24.1 19.9909 24.1 20.463 24.0499C20.9373 23.9995 21.2871 23.8974 21.5599 23.6819C21.8361 23.4638 21.9703 23.1794 22.0358 22.7946C22.1 22.4176 22.1 21.932 22.1 21.3021V21.2923V15.7077V15.6979C22.1 15.068 22.1 14.5824 22.0358 14.2054C21.9703 13.8206 21.8361 13.5362 21.5599 13.3181C21.2871 13.1026 20.9373 13.0005 20.463 12.9501C19.9909 12.9 19.3805 12.9 18.5778 12.9H18.5714Z",
    stroke: "url(#paint0_linear_54_1081)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 15.7077C4 14.4313 4 13.7931 4.5021 13.3965C5.00421 13 5.81233 13 7.42857 13H18.5714C20.1877 13 20.9958 13 21.4979 13.3965C22 13.7931 22 14.4313 22 15.7077V21.2923C22 22.5687 22 23.2069 21.4979 23.6035C20.9958 24 20.1877 24 18.5714 24H15.4451V20.7294C15.4451 20.2515 14.8399 18.8177 13.0244 18.8177C11.572 18.8177 10.6037 20.2515 10.6037 20.7294V24H7.42857C5.81233 24 5.00421 24 4.5021 23.6035C4 23.2069 4 22.5687 4 21.2923V15.7077Z",
    fill: "#67B6FE",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4451 24V20.7294C15.4451 20.2515 14.8399 18.8177 13.0244 18.8177C11.572 18.8177 10.6037 20.2515 10.6037 20.7294V24H15.4451Z",
    fill: "#67B6FE",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_54_1081",
    x: -4.19995,
    y: 4.8,
    width: 34.3999,
    height: 27.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_54_1081"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_54_1081",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_54_1081",
    x: 0,
    y: 9,
    width: 26,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_54_1081"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_54_1081",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_54_1081",
    x1: 2.71429,
    y1: 14,
    x2: 21.5119,
    y2: 29.8821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Upload.d2fabf10.svg";
export { ForwardRef as ReactComponent };